export default __webpack_public_path__ + "static/uz-5385e47c1683c923961dd08f714a343b.png";